module.exports = __webpack_public_path__ + "media/images/emblems/CheneBougeries-coat_of_arms-926c4ea8882013ae96776c4dee4f9abb.svg";